import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"variable\":\"--text-font\"}],\"variableName\":\"workSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/StoreProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/home/header/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/LazyMyAliceChat.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/style/scss/style.scss");
